import { render } from "./InfoHouses.vue?vue&type=template&id=3d339472&scoped=true"
import script from "./InfoHouses.vue?vue&type=script&lang=js"
export * from "./InfoHouses.vue?vue&type=script&lang=js"

import "./InfoHouses.vue?vue&type=style&index=0&id=3d339472&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d339472"]])

export default __exports__